/**
 * useOmnitechApp
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import OmnitechAppContext from './omnitech-app-context'

const useOmnitechApp = () => {
  const context = useContext(OmnitechAppContext)
  return context
}

export default useOmnitechApp
